export default {
  fields: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  field:[],
  selected_fields : {},
  fields_status:[]
}
